import { configureStore } from '@reduxjs/toolkit';

import wizardReducer from './wizardSlice';

// We will add slices here as we migrate features (e.g., UI layout state, multi-step wizards)
export const store = configureStore({
  reducer: {
    wizard: wizardReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {ui: UIState, wizard: WizardState}
export type AppDispatch = typeof store.dispatch;
